import Vue from 'vue';

export default {
  name: 'Pagination',
  props: {
    totalPages: {
      type: Number,
      default: 0,
      required: true
    },
    enableGoToEndBegining: {
      type: Boolean,
      default: true
    },
    onPageChange: {
      type: Function,
      required: true
    }
  },
  data: function () {
    return {
      totalItems: [],
      displayItems: [],
      selectedPage: 1,
      displayPagination: true,
    }
  },
  computed: {},
  watch: {
    totalPages: function (val) {
      this.displayPagination = val > 1 ? true : false;
    },
  },
  created() {
    if (this.totalPages > 1)
      this.init();
    else
      this.displayPagination = false;
  },
  methods: {
    init() {
      for (let i = 1; i <= this.totalPages; i++)
        this.totalItems.push(i);
      this.paginate(1);

    },
    paginate(item) {
      let tempPage = 0;
      if (item == null || !this.isPageInBoundsCheck(item) || item == '')
        return;

      else if (item == 'next') {
        tempPage = this.selectedPage + 1;
        if (this.isPageInBoundsCheck(tempPage))
          this.selectedPage = tempPage;
      }

      else if (item == 'previous') {
        tempPage = this.selectedPage - 1;
        if (this.isPageInBoundsCheck(tempPage))
          this.selectedPage = tempPage;
      }

      else if (item == 'gotToBegining')
        this.selectedPage = 1;

      else if (item == 'gotToEnd') 
          this.selectedPage = this.totalPages;

      else {
        this.selectedPage = item;
      }

      if (this.displayPagination == true)
        this.onPageChange(this.selectedPage);

      this.createPaginationDisplayItems();
    },
    createPaginationDisplayItems() {
      var sel = this.selectedPage;
      var strt = sel - 3;
      var end = sel + 2;

      if (strt < 1)
        this.displayItems = this.totalItems.slice(0, 5);
      else if (end > this.totalPages)
        this.displayItems = this.totalItems.slice(this.totalPages - 5, this.totalPages);
      else
        this.displayItems = this.totalItems.slice(strt, end);
    },
    isPageInBoundsCheck(page) {
      if (page > this.totalPages || page < 1)
        return false;
      else
        return true;

    },
    getClass(item) {
      if (item == this.selectedPage)
        return 'active';
      else
        return;
    },
  },
}
